import { Box, Button, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import PageCard from "../../../components/page-card";
import { translate } from "../../../i18n";
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { useSetCoachPricingRules } from "../hooks/useSetCoachPricingRules";
import CoachPricingEditor from "./CoachPricingEditor";

type Props = { coachs: CoachDto[] };

export default function CoachPricingManagementList({ coachs }: Props) {
    const [editedCoachs, setEditedCoachs] = useState<CoachDto[]>(coachs);
    const toast = useToast();

    useEffect(() => {
        setEditedCoachs(coachs);
    }, [coachs]);

    const { mutateAsync: setCoachPricingRules, isLoading: isSetting } = useSetCoachPricingRules((newRules) => {
        setEditedCoachs(prevEditedCoachs =>
            prevEditedCoachs.map(coach => ({
                ...coach,
                pricingRules: newRules.filter(rule => rule.coachId === coach.id),
            }))
        );
    });

    return (
        <PageCard title={translate('tabs.coach_pricing')}
            rightHeader={
                <Button
                    colorScheme="brand"
                    isLoading={isSetting}
                    onClick={() => {
                        setCoachPricingRules({ rules: editedCoachs.flatMap(coach => coach.pricingRules) })
                            .catch(() => {
                                toast({ title: translate('error'), status: 'error', duration: 3000 });
                            });
                    }}>
                    {translate('save')}
                </Button>
            }>
            <Box gap={4} display='flex' flexDirection={'column'} minWidth={0} overflow="hidden">
                {editedCoachs.map(coach => (
                    <CoachPricingEditor
                        key={coach.id}
                        title={`${coach.firstName} ${coach.lastName}`}
                        coach={coach}
                        pricingRules={coach.pricingRules}
                        setPricingRules={(newRules) => {
                            setEditedCoachs(prev =>
                                prev.map(c => c.id === coach.id ? { ...c, pricingRules: newRules } : c)
                            );
                        }} />
                ))}
            </Box>
        </PageCard>
    );
}
